import React from 'react';
import { Box } from '@mantine/core';
import { GRAY, MOBILE } from '../constants';

/** A titled white tile in the comparison matrix — the attribute label repeated per column. */
export const ColumnBlock: React.FC<{ title: React.ReactNode; children: React.ReactNode }> = ({ title, children }) => (
  <Box sx={{ padding: 18, [MOBILE]: { padding: 12 } }}>
    <Box fw={600} lh={1.2} c={GRAY} sx={{ fontSize: 14, marginBottom: 8, [MOBILE]: { fontSize: 11, marginBottom: 5 } }}>
      {title}
    </Box>
    {children}
  </Box>
);
